import React from 'react';
import { Explorer } from 'src/features/DA/components/templates/Explorer';
import { Page } from '../../components/molecules/Page';
import { DAKeyMetrics } from '../../features/DA/components/organisms/DAKeyMetrics';
import { FilterBar } from '../../components/organisms/FilterBar';
import { GenAIActionButtons } from 'src/components/molecules/GenAIActionButtons';

export const ExplorerPage: React.FC = () => {
  return (
    <Page
      filterBar={<FilterBar includeBenchmark />}
      pageTitle="Campaign Explorer"
      pageSubtitle="Track your project and goal with full information"
      keyMetrics={<DAKeyMetrics />}
      extraButtons={<GenAIActionButtons />}>
      <Explorer />
    </Page>
  );
};
